export const environment = {
  production: false,
  envtype: 'production',
  ApiBaseUrl: 'https://superariapi.devservices.uk/api/',
  StripeKey: 'pk_test_51RGdybQCiu0uz20XP0GSWicX3IAD29S00H0eFzqXv7UZ6mhCGBxOBdA8JdmORN2I05seCXCQmNyMYopRHHRipnWP00RMuQdp4U',
  isUnderMaintance: false,
  G_APIKey: "AIzaSyDrlDapT2LC38At3uGQB9XOTL7LntIutLg",
  latitude: 51.509865,
  longitude: -0.118092,
  noIndex: true
};
